import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { useParams, useNavigate, Routes, Route } from "react-router-dom";
import {
  Card,
  CardContainer,
  CollectionContainer,
  Heading,
  ImageContainer,
  RankTitle,
  DetailsContainer,
  Pagination,
  Button,
  CollectionData,
  StyledHeading,
} from "./styles";

const Banner = styled.div`
  // margin-bottom: 2rem;
  min-height: 17vh;
  position: relative;
  z-index: 0;
  padding: 4rem 0rem;
  &:before {
    content: "/";
    position: absolute;
    width: 100%;
    z-index: 0 !important;
    background: red;
    min-height: 20vh;
    margin-top: 0rem;
    border-radius: 0rem 0rem 1rem 1rem;
    background: url(../../../gbetbackground.jpeg);
    background-color: rgba(0, 0, 0, 0.4);
    background-size: cover;
    box-shadow: inset 0 0 0 2000px rgb(0, 0, 0, 0.77);
    filter: blur(3px);
    @media (max-width: 768px) {
      width: 100%;
      left: 0%;
      min-height: 20vh;
    }
    @media (min-width: 1400px) {
      left: 0%;
      box-shadow: inset 0 0 0 4000rem rgb(0, 0, 0, 0.77) !important;
    }
  }
`;

const Collection = ({}) => {
  const collection = "gangstabet";
  const collection_url = "https://gangstabet.io";
  const [nfts, setNfts] = useState();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  let { name } = useParams();

  const handlePrevious = async () => {
    if (page > 1) {
      setNfts(undefined);
      setPage((prevState) => prevState - 1);
    }
  };
  const handleNext = async () => {
    if (page < 56) {
      setNfts(undefined);
      setPage((prevState) => prevState + 1);
    }
  };
  useEffect(() => {
    async function fetchdata() {
      if (collection === name) {
        setLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/v1/score/getall?page=${page}`
        );
        setNfts(res.data.data);
        setLoading(false);
      } else {
        console.log("No collection match found");
      }
    }
    fetchdata();
  }, [page]);

  return (
    <CollectionContainer>
      <Banner>
        <StyledHeading>{name.toUpperCase()} NFT Rarity Rank</StyledHeading>
      </Banner>
      <CollectionData>
        {loading ? (
          <div style={{ margin: "auto", marginTop: "20vh", minHeight: "40vh" }}>
            <Heading style={{ textAlign: "center", color: "#393939" }}>
              Loading...
            </Heading>
          </div>
        ) : (
          <>
            <CardContainer>
              {nfts &&
                nfts.length > 0 &&
                nfts.map((each, key) => {
                  return (
                    <EachCard nft_data={each} key={key} name={name} yarn />
                  );
                })}
            </CardContainer>
            {nfts && nfts.length > 0 && (
              <Pagination
                style={{
                  justifyContent: "space-around",
                  width: "50%",
                  margin: "2rem auto",
                }}
              >
                <Button
                  style={{ background: "#3772FF" }}
                  onClick={() => handlePrevious()}
                >
                  Prev
                </Button>
                <Button
                  style={{ background: "#3772FF" }}
                  onClick={() => handleNext()}
                >
                  Next
                </Button>
              </Pagination>
            )}
          </>
        )}
      </CollectionData>
    </CollectionContainer>
  );
};

const EachCard = ({ nft_data, name }) => {
  const navigate = useNavigate();
  const handleCardClick = (nft_data) => {
    navigate(`/profile/${nft_data.id}`);
  };
  return (
    <Card onClick={() => handleCardClick(nft_data)}>
      <RankTitle>
        <span>
          Rank: <span>#{nft_data?.v2_percentage_rank}</span>
        </span>
      </RankTitle>
      <ImageContainer>
        <img src={nft_data?.image_url} alt="gif" />
      </ImageContainer>
      <DetailsContainer>
        <span style={{ color: "393939", fontSize: "1rem", fontWeight: "bold" }}>
          {nft_data?.name}
        </span>
        <br />
        <span style={{ color: "#FF1B71" }}>
          Score:{" "}
          <span style={{ fontWeight: "500" }}>
            {nft_data.v2_total_score.toFixed(3)}
          </span>
        </span>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Button
            style={{
              background: "#F7F7F7",
              color: "#393939",
            }}
          >
            ID: {nft_data?.id}
          </Button>
          <Button>View Nft</Button>
        </div>
      </DetailsContainer>
    </Card>
  );
};

export default Collection;
